import React from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from '../../Redux/modalSlice';
import './Cards.css';

export const Cards = ({ work, description, img, skills, linkUrl }) => {
  const dispatch = useDispatch();
  const cover = img?.[0];

  const openModalHandler = () => {
    dispatch(
      openModal({
        work,
        description,
        img,
        skills,
        linkUrl,
      })
    );
  };

  return (
    <article className="project-card">
      <div className="project-card-window-bar">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
      <div className="project-card-content">
        <h3 className="project-card-title-main">{work}</h3>
        <p className="project-card-description-alt">{description}</p>
        <div className="project-card-skills">
          {skills?.slice(0, 4).map((skill, index) => (
            <span key={index} className="skill-tag">{skill}</span>
          ))}
        </div>
        <button type="button" className="project-card-main" onClick={openModalHandler}>
          <div className="project-card-img">
            <img src={cover} alt={work} loading="lazy" />
            <div className="project-card-overlay">
              <span className="project-card-hover-cta">Explorar Proyecto</span>
            </div>
          </div>
        </button>
      </div>
    </article>
  );
};
